import React from 'react';

function ContentSection(props) {
    const { maxWidth = 1200, minHeight = 800, style = {} } = props;

    React.useEffect(() => {
          window.scrollTo(0, 0);
      }, []);

    return (<div style={{ minHeight }}>
        <div style={{ margin: '0 auto', maxWidth, paddingTop: 20, paddingLeft: 20, paddingRight: 20, ...style }}>
            {props.children}
        </div>
    </div >)
}

export default ContentSection;


// WEBPACK FOOTER //
// ./src/home/components/ContentSection.js